<template>
  <div class="the-navbar__user-meta flex items-center cursor-pointer contact-info-box" @click="goToTicketing">
    <div class="text-center leading-tight hidden sm:block" style="width: max-content;">
      <p class="user-name">{{ name }}</p>
      <p class="role-name">{{ role }}</p>
    </div>
  </div>
</template>

<script>

import Import from '../../../../views/components/extra-components/import-export/Import';
import ImpersonateModal from '@/layouts/components/navbar/components/ImpersonateModal';
import store from '@/store/store';

export default {
  components: {
    Import,
    ImpersonateModal,
  },
  props: {
    name: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: true
    },
    contactPK: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showImpersonateModal: false,
      canImpersonate: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    roleName() {
      const role = this.user.company.roles.filter((role) =>
          role.applications[0].ExternalIdentity_Key === process.env.VUE_APP_AUTH0_CLIENT_ID
      );

      return role[0].RoleName;
    },
  },
  async created() {
    await this.chectImpersonatePrivilege();
  },
  methods: {
    async logout () {
      // if user is logged in via auth0
      await this.$store.dispatch('auth/logout');
    },
    async chectImpersonatePrivilege() {
      const privilegesData = store.getters['personas/privileges'];
      const impersonatePrivilege = privilegesData.find((navAccessItem) => navAccessItem.PageName === 'impersonate_company');

      if (!impersonatePrivilege) {
        return false;
      }
      
      this.canImpersonate = impersonatePrivilege.View;

      return this.canImpersonate;
    },
    goToTicketing() {
      let url = process.env.VUE_APP_HEADER_TICKET_LINK;
      const params = {
        type: 'GE',
        org: 'FUW',
        ext: this.contactPK,
      }

      const queryString = new URLSearchParams(params).toString();
      url = `${url}?${queryString}`;
      window.open(url, '_blank');
    }
  }
}
</script>

<style lang="scss">
@import '../../../../assets/scss/custom/components/variables';

.contact-info-box {
  min-width: 120px;
}

.the-navbar__user-meta {
  background-color: $grey-darkest;
  border: 1px solid $grey-darkest;
  border-radius: 5px;
  padding: 10px 15px;
  color: #fff;
  //width: 200px;
  height: 50px;

  .role-name {
    color: $yellow;
    font-size: 10px;
  }
}
</style>
